import type { StartContext } from "@/lib/startApi";

/**
 * Where a bot check widget goes on the start page. The server says whether
 * one is wanted (`turnstile` on the start context); while it says null, which
 * is always for now, this renders nothing at all.
 *
 * When it is set, this renders the empty container a widget mounts into. The
 * widget and its token are not built yet; the send and sign-in calls already
 * accept an optional token.
 */
export function TurnstileSlot({
  config,
  placement,
}: {
  config: StartContext["turnstile"];
  placement: "code" | "sign-in";
}) {
  if (!config) return null;
  return <div data-turnstile-slot={placement} />;
}
